export default __webpack_public_path__ + "static/media/SampleNewsArticle.74f5785c.png";